<template>
  <div class="flow-groups">
    <FlowGroup
      v-for="group in groups"
      :key="group.id"
      :group="group"
      v-model="group.id"
      :selected="selectedGroupsIds.includes(group.id)"
      @select-item="toggleSelected(group.id)"
      :full="full"
      :timezone="timezone"
    />
  </div>
</template>

<script>
import FlowGroup from './FlowGroup.vue';
export default {
  name: 'flow-groups',
  components: {FlowGroup},
  props: {
    groups: {
      type: Array,
      required: true,
    },
    selectedGroupsIds: {
      type: Array,
      required: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
    },
  },
  methods: {
    toggleSelected(id) {
      this.$emit('toggle-item', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-groups {
  display: grid;
  grid-template-columns: 1fr;
  -ms-grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  gap: 16px;
  max-height: 272px;
  overflow: auto;

  @media (min-width: $breakpoint-lg) {
    grid-template-columns: repeat(3, 1fr);
    -ms-grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #9e9e9e;
    border: none;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 8px;
  }
}
</style>
